"use client";

import { Passionate } from "@/components/About/Passionate/Passionate";
import { ExcellenceAwards } from "@/components/common/ExcellenceAwards/ExcellenceAwards";
import HeroAbout from "@/components/About/HeroAbout/HeroAbout";
import { Join } from "@/components/About/Join/Join";
import { Metrics } from "@/components/About/Metrics/Metrics";
import TechExperts from "@/components/About/TechExperts/TechExperts";
import { Footer } from "@/components/layout/Footer/Footer";
import TeamLiderPlaceHolder from "@/components/About/TeamLiderPlaceHolder/TeamLiderPlaceHolder";
import style from "./Section.module.scss";
import { useGsapBurgerTimeline } from "@/utils/useGsapBurgerTimeline";
import Team from "@/components/About/Team/Team";
const SectionAbout = ({ messages }) => {
  useGsapBurgerTimeline({
    triggerClass: style.aboutBgPrimary,
  });
  return (
    <div className={`${style.pageWrapper} about-page-wrap`}>
      <div className="content">
        <HeroAbout messages={messages?.aboutHero} />
        <TechExperts messages={messages?.experts} />
      </div>
      <div className={style.aboutBgPrimary}>
        {messages?.teamSection &&
        messages?.teamSection?.team &&
        messages?.teamSection?.team?.length > 0 ? (
          <TeamLiderPlaceHolder messages={messages?.teamSection} />
        ) : null}
        <Team messages={messages?.teamSection} />
        <Metrics messages={messages?.metrics} />
        <Join messages={messages?.joinUs} />
      </div>

      <Passionate messages={messages?.passionate} />
      <ExcellenceAwards messages={messages?.awardsSection} />
      <Footer />
    </div>
  );
};

export default SectionAbout;
